module.exports = __webpack_public_path__ + "static/media/dna-logo.b7ce0068.jpg";